import React, { useMemo } from "react";
import styles from "../styles.module.scss";
import { TableCell, TableRow, styled } from "@mui/material";
import { ProgressWrapper } from "./ProgressWrapper";
import {
  calculateProgressNew,
  parseDateTime,
  formatDate,
} from "../utils/progressCalculations";
import { formatPrice } from "../utils/formatters";

// Старая MUI-вёрстка строк — оставлена как _old, заменена грид-вёрсткой как в клиенте
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledTableCell_old = styled(TableCell)({
  padding: "8px",
  border: "none",
  "&.MuiTableCell-root": {
    padding: "0 !important",
  },
  "&:first-of-type": {
    width: "100px",
    color: "var(--ui-text-secondary-default)",
    fontSize: "12px",
  },
  "&:nth-of-type(2)": {
    width: "120px",
    color: "var(--ui-text-caption-default)",
    fontSize: "12px",
  },
  "&:last-child": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    width: "auto",
    paddingRight: "24px",
  },
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledTableRow_old = styled(TableRow)({
  color: "inherit",
  display: "flex",
  verticalAlign: "middle",
  outline: 0,
  "&.MuiTableRow-root": {
    padding: "0 !important",
    alignItems: "center",
    height: "40px !important",
  },
});

interface VisitRowProps {
  visit: any;
  date: string;
  keywordStatus?: string;
  orderType: string;
  dataType: 'visits' | 'installs';
  pricePerUnit?: number;
}

export const VisitRow: React.FC<VisitRowProps> = ({
  visit,
  date,
  dataType,
  pricePerUnit
}) => {
  const timeRange = (visit?.startTime ?? "") + " - " + (visit?.endTime ?? "");
  // Безопасный расчёт total
  const totalRaw = visit.total ?? 0;
  const total = typeof totalRaw === 'number' && !isNaN(totalRaw) ? totalRaw : parseInt(totalRaw) || 0;
  // Прогресс по времени
  const startDate = parseDateTime(visit?.date, visit?.startTime);
  const endDate = parseDateTime(visit?.date, visit?.endTime);
  let calculatedProgress = 0;
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const visitDate = visit.date;
  if (new Date(visitDate) > today) {
    calculatedProgress = 0;
  } else if (new Date(visitDate) < new Date(todayStr)) {
    calculatedProgress = 100;
  } else {
    calculatedProgress = calculateProgressNew(startDate, endDate);
  }
  // Прогресс дня с бэка (как в клиенте), локальный расчёт — fallback
  const totalProgress =
    visit?.completedPercentage !== null && visit?.completedPercentage !== undefined
      ? Math.round(Number(visit.completedPercentage))
      : calculatedProgress;
  // Безопасный расчёт current
  const currentRaw = dataType === 'visits'
    ? (visit.visits ?? visit.pageViews ?? 0)
    : (visit.installs ?? 0);
  const current = typeof currentRaw === 'number' && !isNaN(currentRaw) ? currentRaw : parseInt(currentRaw) || 0;
  // displayedCount по прогрессу
  const progressPercentage = totalProgress / 100;
  const displayedCount = Math.round(total * progressPercentage);
  // Цена
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const dailyPrice_old = total > 0 && pricePerUnit ? pricePerUnit * total : 0;
  // Как в клиенте: цена дня приходит с бэка (completedPrice/price), не пересчитывается
  const dailyPrice =
    totalProgress === 0 ? 0 : Number(visit?.completedPrice ?? visit?.price ?? 0);
  // Вёрстка как в клиенте (VisitRow): грид date | time | progress | count | price
  return (
    <div className={styles.visitRow}>
      <div className={styles.visitRowDate}>{formatDate(date)}</div>
      <div className={styles.visitRowTime}>{timeRange}</div>
      <div className={styles.visitRowProgress}>
        <ProgressWrapper
          value={totalProgress}
          status={totalProgress === 100 ? "DONE" : "INPROGRESS"}
        />
      </div>
      <div className={styles.visitRowCount}>
        <span className={styles.visitRowCountTitle}>
          {isNaN(displayedCount) ? 0 : displayedCount}
        </span>
        <span className={styles.visitRowCountDesc}>
          /{isNaN(total) ? 0 : total}
        </span>
      </div>
      <div className={styles.visitRowPrice}>{formatPrice(dailyPrice)}</div>
    </div>
  );
};
